import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";
import { setLogin } from "./userSlice";

const initialState = {
    isLoading: false,
    isResending: false,
    registerData: {},
    errorMsg: "",
    isError: false
}





export const registerAffiliateWithGoogle = createAsyncThunk('registerAffiliateWithGoogle', async (body, { rejectWithValue, dispatch }) => {
    try {
        
        const { data, status } = await api.registerAffiliateWithGoogle(body);
        dispatch(setLoading(true))

        console.log(data,"data!--------");
        
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setRegister(true))
                Toastify.success("Affiliate Registered successfully");
                localStorage.setItem("affiliatetoken",data.data.token)
                localStorage.removeItem("token")

        }
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const registerAffiliate = createAsyncThunk('registerAffiliate', async (body, { rejectWithValue, dispatch }) => {
    try {
        
        const { data, status } = await api.registerAffiliate(body);
        dispatch(setLoading(true))
        
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setRegister(true))
                // Toastify.success("Affiliate Registered successfully");
                // console.log("data reg",data.data)
                // localStorage.setItem("affiliatetoken",data.data.token)
                // localStorage.removeItem("token")
        }
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)


export const registerAffiliateSlice = createSlice({
    name: "affiliateregister",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setRegister: (state, action) => {
            state.registerData = action.payload
        },
        
    },
    
})

export const { setLoading,setRegister, } = registerAffiliateSlice.actions

export default registerAffiliateSlice.reducer;